import {User} from "../../types"
import client, {QueryOptions} from "../../utils/clients/apollo"
import {CURRENT_USER} from "./queries"

interface UserResponse {
  me: User
}

class UserService {
  async getCurrentUser(options: QueryOptions = {}): Promise<User> {
    const res = await client.query<UserResponse>({
      ...options,
      query: CURRENT_USER
    })

    return res.data.me
  }
}

const userService = new UserService()

export default userService
